import ActivityMessaging from '../../molecules/activity-messaging/ActivityMessaging';
import Badge, { BadgeVariant } from '../../atoms/badge/Badge';
import IconHektor from '../../icons/IconHektor.tsx';
import IconLegal from '../../icons/IconLegal.tsx';
import IconAkademieMono from '../../icons/IconAkademieMono.tsx';
import { ActivityMessagingType } from './ActivityMessagingPreview.types.ts';
import React, { useMemo } from 'react';

export type ActivityMessagingDefaultFieldProps = {
  type: string;
  title?: string;
  content?: string;
};

const BADGE_CONFIG: Partial<
  Record<ActivityMessagingType, { label: string; icon: React.ReactNode }>
> = {
  [ActivityMessagingType.UPDATE]: {
    label: 'Mise à jour Hektor',
    icon: <IconHektor className="size-3" />,
  },
  [ActivityMessagingType.LEGAL]: {
    label: 'Juridique',
    icon: <IconLegal className="size-3" />,
  },
  [ActivityMessagingType.FORMATION]: {
    label: 'Formation',
    icon: <IconAkademieMono className="size-3" />,
  },
};

export const ActivityMessagingDefaultField = ({
  type,
  title,
  content,
}: ActivityMessagingDefaultFieldProps) => {
  const badgeConfig = useMemo(
    () => BADGE_CONFIG[type as ActivityMessagingType] || null,
    [type],
  );

  return (
    <ActivityMessaging.Root>
      {badgeConfig && (
        <Badge
          variant={BadgeVariant.BRAND}
          className="self-start font-semibold uppercase"
        >
          {badgeConfig.icon}
          {badgeConfig.label}
        </Badge>
      )}

      <div className="flex flex-col gap-0.5">
        {title && <ActivityMessaging.Title>{title}</ActivityMessaging.Title>}

        <ActivityMessaging.ExpandableContent enableResizeObserver>
          <ActivityMessaging.Content activity={{ description: content }} />
        </ActivityMessaging.ExpandableContent>
      </div>
    </ActivityMessaging.Root>
  );
};
